const helpers = {
    /**
     * Get the value of a cookie
     * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
     * @param  {String} name  The name of the cookie
     * @return {String}       The cookie value
     */
    getCookie(name) {
        let value = `; ${document.cookie}`;
        let parts = value.split(`; ${name}=`);
        if (parts.length === 2)  {
            return parts.pop().split(';').shift();
        }
        return false;
    },

    setSecureCookie(advertising_cookie,cookieName) {
        //e.preventDefault();
        const date = new Date();
        const ttl = advertising_cookie.dataset.lightboxPromotionTtl
            ? parseInt(advertising_cookie.dataset.lightboxPromotionTtl, 10)
            : 1;

        // Set the cookie
        date.setDate(date.getDate() + ttl);
        document.cookie =
            `${cookieName}=1; expires=${date.toUTCString()};` +
            `path=/;secure`;
    },

    /* Merge phone prefix and phone number.*/
    mergePhonePrefixAndPhoneNumber(phonePrefix, phoneNumber) {
        let finalPhoneNumber = phonePrefix.replace('+', '00');
        phoneNumber = phoneNumber.replace(/%20/g,'');
        phoneNumber = phoneNumber.replace(/\D/g,'');
        finalPhoneNumber += phoneNumber;
        return finalPhoneNumber;

    },

    scrolledOverH1Headline(firstHeadline, footerHeight, documentHeight) {
        let currentScrollPosition = window.scrollY;
        let firstHeadlineYPosition = firstHeadline.getBoundingClientRect().y;
        if (currentScrollPosition > firstHeadlineYPosition && (currentScrollPosition + window.innerHeight) < (documentHeight - footerHeight)) {
            return true;
        } else {
            return false;
        }
    }

}

export { helpers as default };
